<template>
  <div class="carList full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
      @click-left="onClickRight"
    >
      车型列表
    </ld-header>
    <!-- 出发信息等内容  -->
    <div class="pad-lr-6">
      <div class="carListwrapper">
        <mescroll-vue ref="mescroll" :down="down">
          <!-- 接机 -->
          <van-cell v-if="carlistdata.useType==4">
            <van-row type="flex" align="center">
              <van-col span="3">
                <img width="26" :src="flightNo" alt="." class="vertical-bottom">
              </van-col>
              <van-col span="21">
                <van-cell :title="carlistdata.departure_place" :label="carlistdata.fromAddress" class="van-hairline--bottom"/>
              </van-col>
            </van-row>
            <van-row type="flex" align="center">
              <van-col span="3">
                <img width="26" :src="xcPlace" alt="." class="vertical-bottom">
              </van-col>
              <van-col span="21">
                <van-cell :title="carlistdata.toLocationName" :label="carlistdata.toAddress" class="van-hairline--bottom"/>
              </van-col>
            </van-row>
          </van-cell>
          <!-- 送机 -->
          <van-cell v-else>
            <van-row type="flex" align="center">
              <van-col span="3">
                <img width="26" :src="xcPlace" alt="." class="vertical-bottom">
              </van-col>
              <van-col span="21">
                <van-cell :title="carlistdata.fromLocationName" :label="carlistdata.fromAddress" class="van-hairline--bottom"/>
              </van-col>
            </van-row>
            <van-row type="flex" align="center">
              <van-col span="3">
                <img width="26" :src="flightNo" alt="." class="vertical-bottom">
              </van-col>
              <van-col span="21">
                <van-cell :title="carlistdata.destination" :label="carlistdata.toAddress" class="van-hairline--bottom"/>
              </van-col>
            </van-row>

          </van-cell>
           

          <!-- 用车列表 -->
          <transition-group
            tag="div"
            name="van-slide-right"
          >
            <div
              v-for="(info, index) in list"
              :key="info.vehicleTypeName"
              class="box"
              @click="check(info,index)"
            >
              <van-card
                :thumb="info.coverUrl"
                class="round-sm"
              >
                <div slot="title">
                  <span class="font16 font-lg">{{ info.vehicleTypeName }}</span>
                  <span class="fr">
                    <span class="money-color font10">￥</span>
                    <span class="money-color font16 font-lg">{{ info.detailBeanList[0].salePrice }} </span>
                    <span class="gray font10">起</span>
                  </span>
                </div>
                <div
                  slot="desc"
                  class="pad-tb-5"
                >
                  <ld-icon class="iconfont iconchangyongicon-" />×{{ info.luggageNum }}
                  &nbsp;
                  <ld-icon class="iconfont icongerentouxiang_o" />×{{ info.personNum }}
                </div>
                <div
                  slot="tags"
                  class="gray"
                >
                  {{ info.vehicleTypeDesc }}
                </div>
                <div
                  slot="footer"
                  v-show="info.checked"
                  class="van-hairline--top"
                >
                  <van-row
                    type="flex"
                    align="center"
                    justify="space-between"
                    class="p-t-15"
                    v-for="pd in info.detailBeanList"
                    :key="pd.productId"
                  >
                    <van-col
                      span="12"
                      class="text-left"
                    >
                      <img
                        class="round-sm vertical-middle"
                        width="24"
                        :src="pd.priceFromUrl"
                      >
                      &nbsp;
                      <span class="font14">{{ pd.priceFromName }}</span>
                    </van-col>
                    <van-col span="3">
                      <!-- <van-tag
                          v-show="iswb(pd)"
                          type="danger"
                        >
                          {{ $t('K303','违') }}
                        </van-tag> -->
                    </van-col>
                    <van-col
                      span="4"
                      class="text-center money-color font14"
                    >
                      ￥{{ pd.salePrice }}
                    </van-col>
                    <van-col span="5">
                      <!-- :main="canbook(pd)" //按扭是否处于主色调
                          :gray="!canbook(pd)"//按扭是否处于灰色 -->
                      <ld-button
                        size="md"
                        :main="canbook(pd)"
                        :gray="!canbook(pd)"
                        @click.stop="canbook(pd) && book(info, pd)"
                      >
                        {{ $t('B003','预订') }}
                      </ld-button>
                    </van-col>
                  </van-row>
                </div>
              </van-card>
            </div>
          </transition-group>
          <!-- 复印原文件 -->
          <ld-call-service
            style=""
            class="zhuanshukefu"
            name="van-fade"
            v-if=" loginConfig && loginConfig.pageName && loginConfig.pageName.indexOf('柒个贰') > -1"
            from="10906"
          />
        </mescroll-vue>

      </div>
    </div>
    <!-- 复印原文件 -->
    <violate-list
      cplx="10906"
      ref="violateList"
      :violate="clzcStr"
      @selected="() => book()"
    />
  </div>
</template>
<script>
// import { CONSOLE_MONITOR_ENABLE } from '@/business/config';
import { mapGetters } from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldButton from 'Common/ldButton'
import mixin from 'Views/Car/carQuery/mixin.js'
import violateList from 'Components/violateList'
//小点
import xcPlace from 'Assets/images/car/xcPlace.png'
// 飞机
import flightNo from 'Assets/images/car/flightNo.png'



import {Cell,Card, Checkbox, CheckboxGroup, Dialog,   Tag,Collapse, CollapseItem,ContactCard,
  Button, 
  Tab, 
  Tabs,
  CellGroup ,
  Field,
  Popup,
} from 'vant'

export default {
  name: 'CarListcom',
  mixins: [mixin],
  components: {
    [Cell.name]: Cell,
    [Card.name]: Card,
    MescrollVue,
    ldButton,
    violateList
        
  },
  props: {
    flights:{
      type: Object,
    },
    carlistdata:'',//获取用车列表参数
  },
  data(){
    return{
      down: { use:false },
      xcPlace:xcPlace,
      flightNo:flightNo,
      one:'乐滨-太平国际机声',
      tow:'乐滨-太平国际机声',
      cacheId:'',
      list:'',
      clzcStr:""
            
    }
  },
  created(){
  },
  computed:{
    ...mapGetters({
      tripType: 'tripType',
      loginConfig: 'loginConfig',
    })
  },
  methods:{
    onClickRight(){
      this.$emit('onClickRight')
    },
    //获取用车列表
    carlist(item){
      this.list=''
      // console.log('触发相关事件')
      //传入公共内容
      let {empInfo} = JSON.parse(localStorage.getItem('userInfo')) ;
      console.log('获取本地存储的地方',empInfo)
      item.customerMobile=empInfo.phoneNumber//登陆人手机号
      item.customerName=empInfo.empName//登陆人姓名
      item.empId=empInfo.empId//登陆人id
      item.tripType=this.tripType//因公因私
      this.$api['carQuery/estimateYyycPrice'](item)
        .then(res => {
          let cache = res.data || {}
          let typeList=cache.typeList||[]
          this.cacheId=cache.cacheId||''
          if(typeList.length==0){
            this.$dialog.alert({
              title:this.$t('C474','提示'),
              message:'未查询到符合条件的用车数据'
            })
          }
          for (let i = 0; i < typeList.length; i++) {
            typeList[i].detailBeanList.sort((x,y) => {
              return x.salePrice - y.salePrice
            })
          }

          // 如果有 订单金额上限 - 差旅匹配为不允许预订
          // if (info.limitAmount) {
          // 	typeList.forEach(types => {
          // 		types.detailBeanList.forEach(priceDetail => {
          // 			var limitMatch = {
          // 				cityLevelCode:'1',
          // 				clzcValue: info.limitAmount,
          // 				gkfs: 2,
          // 				sfwb: (priceDetail.salePrice + priceDetail.serviceFee) > info.limitAmount ? '1' : '0'
          // 			}
          // 			if (priceDetail.clzcMatch) {
          // 				Object.assign(priceDetail.clzcMatch, limitMatch)
          // 			} else {
          // 				priceDetail.clzcMatch = limitMatch
          // 			}
          // 		})
          // 	})
          // }

          this.$store.commit('car/setCarList', typeList)
          this.list = typeList

        })
    },
    async book(item, info) {//复印原文件
      //item是什么的数据，info是单条数据
      console.log('item',item,info)
      let UseAccount_DebtYck = await this.UseAccount_DebtYck
      if (!UseAccount_DebtYck) {
        this.$dialog({message: '产品未开通，如需开通产品预订请联系客服。'})
        return
      }

      if (item) this.detailBeanList = item
      if (info) this.detailBean = info

      // 差标拦截
      if (info && this.iswb(info)) {
        this.clzcStr = this.genViolateDesc(this.detailBean)
        this.$refs.violateList.toggle({ violate: this.clzcStr, cplx: '10906' }) // 选择违背原因
        return
      } else if (info && !this.canbook(info)) {
        this.clzcStr = this.genViolateDesc(this.detailBean)
        this.$toast(`当前不可预订，因违背${this.clzcStr}`)
        return
      }
      // let obj = Object.assign(this.carlistdata, {cacheId: this.cacheId }, { info: Object.assign(this.detailBeanList, this.detailBean) })
      // console.log('obj',obj)
      // this.$store.commit('car/carSearchInfo', obj)
      // this.$router.push({ path: '/car/carEdit' })
      // let obj=Object.assign(info,item)
      this.$emit('carchecklist',info,item,this.cacheId)
    },
    check(info,index){
      this.$set(this.list[index], 'checked', !this.list[index].checked)
    },
  }
}
</script>

<style lang="less"  scoped>
.boxfromStorn{
  margin-bottom: 50px;
}
.carList {

.pad-lr-6{
    padding:0 6px;
}
.box {
  margin-top: 5px;
}

.van-card__content {
  min-height: auto;
}
.van-card__thumb {
  height: auto;
}
.carListwrapper {
  height: calc(100vh - 46px);
  overflow: hidden;
}
.p-t-15 {
  padding-top: 15px;
}
.pad-tb-5{
    padding: 5px 0;
}
}



</style>